module.exports = __webpack_public_path__ + "img/307.98dd429c.png";